import { useEffect, useState } from "react";
import { GlassContainer } from "../components/Containers";
import { Button, Input, Modal, Typography } from "antd";
import chatrivonobg from "../files/chatrivo_nobg.png";
import {
  DownloadOutlined,
  TeamOutlined,
  ExportOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import Buttons from "../components/Buttons";

const { Title, Text } = Typography;

export default function ProjectChatRivo(args) {
  const [modalOpen, setModalOpen] = useState(false);
  const [user, setUser] = useState({ username: "", password: "" });

  useEffect(() => {
    args.setCurrent("projects");
    document.title = "ChatRivo | Zenofy";
  }, [args]);
  console.log(args.setCurrent);
  return (
    <div style={{ marginTop: "4rem", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <GlassContainer
        width="95vw"
        height="60rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <div
            style={{
              width: "100%",
              height: "100%",

              display: "flex",
              flexDirection: args.device === "phone" ? "column" : "row",
              alignItems: "center",
              justifyContent: "center",
              padding: args.device === "phone" ? "calc(1rem + 3vw) 0" : "0 calc(1rem + 3vw)",

              gap: "calc(4rem + 4vw)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: args.device === "phone" ? "100%" : "30%",
                height: args.device === "phone" ? "30%" : "100%",
              }}
            >
              <img src={chatrivonobg} alt="chatrivo-logo" style={{ width: "70%" }} />
            </div>
            <div
              style={{
                width: args.device === "phone" ? "100%" : "50%",
                height: args.device === "phone" ? "50%" : "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Title
                style={{
                  marginBottom: "1rem",
                  color: "var(--light)",
                  fontSize: args.device === "pc" ? "calc(10px + 4vw)" : "calc(1rem + 9vw)",
                }}
              >
                Arkadaşlarınla Gönlün Rahat Takıl!
              </Title>
              <Text
                style={{
                  marginBottom: "6rem",
                  color: "var(--light)",
                  fontSize: args.device === "pc" ? "calc(2rem + 1vw)" : "calc(1rem + 1vw)",
                }}
              >
                Chatrivo ile arkadaşlarınla buluş, sohbet et ve eğlen.
              </Text>
              <Buttons
                buttonsPrimary={["Hemen Dene!"]}
                buttons={["Forum", "Daha Fazla"]}
                href={["/forum/chatrivo", "https://chatrivo.com"]}
                onClickPrimary={() => setModalOpen(true)}
                disabledPrimary={[]}
                tooltipPrimary={[<Text italic>Kapalı Alpha Sürümünü İndir!</Text>]}
                iconsPrimary={[<DownloadOutlined />]}
                icons={[<TeamOutlined />, <ExportOutlined />]}
                iconPlacement="end"
                device={args.device}
              ></Buttons>
              <Modal
                footer={null}
                open={modalOpen}
                styles={{
                  container: {
                    borderRadius: 14,
                    border: "1px solid #ccc",
                    padding: 0,
                    overflow: "hidden",
                  },
                  header: {
                    padding: 16,
                  },
                  body: {
                    padding: 16,
                  },
                  footer: {
                    padding: "16px 10px",
                    backgroundColor: "#fafafa",
                  },
                }}
                centered={true}
                mask={{ enabled: true, blur: true }}
                onOk={() => setModalOpen(false)}
                onCancel={() => setModalOpen(false)}
                title="Alpha v1.1.3 [20 Mayıs 2026]"
                style={{ alignItems: "center" }}
                bodyStyle={{ display: "flex", flexDirection: "column", alignItems: "center" }}
              >
                <Typography.Title level={3} style={{ textAlign: "center", marginTop: "0", marginBottom: "30px" }}>
                  Kapalı Alpha Sürümünü İndirebilmek için Kimliğini Doğrula
                </Typography.Title>
                <Input
                  size="large"
                  style={{ color: "#1d7595", marginBottom: "5px" }}
                  placeholder="Kullanıcı adı"
                  onChange={(e) => setUser({ username: e.target.value, password: user.password })}
                  prefix={<UserOutlined />}
                />
                <Input.Password
                  size="large"
                  style={{ color: "#1d7595", marginBottom: "5px" }}
                  onChange={(e) => setUser({ username: user.username, password: e.target.value })}
                  iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                  placeholder="Şifre"
                  prefix={<LockOutlined />}
                />
                <Button
                  type="primary"
                  onClick={async () => {
                    try {
                      const response = await fetch("https://api.zenofy.tr/download/AlphaV1.1.3-windows", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify(user), // Data must be stringified
                      });

                      if (response.ok) {
                        const blob = await response.blob();
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", "chatrivo_alpha_setup_v1.1.3.exe");
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);
                        //message.success('İndirme başladı!');
                      } else {
                        //message.error('Kimlik doğrulama başarısız!');
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  {" "}
                  İndir <DownloadOutlined />
                </Button>
              </Modal>
            </div>
          </div>
        }
      ></GlassContainer>
      <Typography.Title style={{ textAlign: "center", color: "white", fontWeight: "bold", fontSize: "4rem" }}>
        Ekran Fotoğrafları <br />
        Alpha v1.1.3 [20 Mayıs 2026]
      </Typography.Title>

      <Typography.Title style={{ textAlign: "center", color: "white", fontWeight: "bold", fontSize: "2rem" }}>
        Bilgisayar Sürümü
      </Typography.Title>
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img src="https://api.zenofy.tr/chatrivo_images/1.png" alt="chatrivo ss" style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }} />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img src="https://api.zenofy.tr/chatrivo_images/2.png" alt="chatrivo ss" style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }} />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img src="https://api.zenofy.tr/chatrivo_images/3.png" alt="chatrivo ss" style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }} />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img src="https://api.zenofy.tr/chatrivo_images/4.png" alt="chatrivo ss" style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }} />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img src="https://api.zenofy.tr/chatrivo_images/5.png" alt="chatrivo ss" style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }} />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img src="https://api.zenofy.tr/chatrivo_images/6.png" alt="chatrivo ss" style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }} />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img src="https://api.zenofy.tr/chatrivo_images/7.png" alt="chatrivo ss" style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }} />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img src="https://api.zenofy.tr/chatrivo_images/8.png" alt="chatrivo ss" style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }} />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img src="https://api.zenofy.tr/chatrivo_images/9.png" alt="chatrivo ss" style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }} />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img
            src="https://api.zenofy.tr/chatrivo_images/10.png"
            alt="chatrivo ss"
            style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }}
          />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img
            src="https://api.zenofy.tr/chatrivo_images/11.png"
            alt="chatrivo ss"
            style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }}
          />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img
            src="https://api.zenofy.tr/chatrivo_images/12.png"
            alt="chatrivo ss"
            style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }}
          />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img
            src="https://api.zenofy.tr/chatrivo_images/13.png"
            alt="chatrivo ss"
            style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }}
          />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img
            src="https://api.zenofy.tr/chatrivo_images/14.png"
            alt="chatrivo ss"
            style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }}
          />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img
            src="https://api.zenofy.tr/chatrivo_images/15.png"
            alt="chatrivo ss"
            style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }}
          />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img
            src="https://api.zenofy.tr/chatrivo_images/16.png"
            alt="chatrivo ss"
            style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }}
          />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img
            src="https://api.zenofy.tr/chatrivo_images/17.png"
            alt="chatrivo ss"
            style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }}
          />
        }
      />
      <GlassContainer
        width="82vw"
        height="10rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <img
            src="https://api.zenofy.tr/chatrivo_images/18.png"
            alt="chatrivo ss"
            style={{ maxWidth: "80vw", padding: "min(1rem,1vw)" }}
          />
        }
      />

      <Typography.Title style={{ textAlign: "center", color: "white", fontWeight: "bold", fontSize: "2rem" }}>
        Mobil Sürümü
      </Typography.Title>
      <div style={{ display: "flex", flexDirection: "row", margin: "1rem", maxWidth: args.device !== "phone" ? "60%" : "150%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "1rem",
            width: args.device === "phone" ? "400%" : "100%",
          }}
        >
          <GlassContainer
            height="150%"
            bigger_height="100%"
            width="100%"
            inside={
              <img
                src="https://api.zenofy.tr/chatrivo_images/mobil-1.jpg"
                alt="chatrivo ss"
                style={{ maxWidth: "90%", paddingBottom: "5%", paddingTop: "5%" }}
              />
            }
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "1rem",
            width: args.device === "phone" ? "400%" : "100%",
          }}
        >
          <GlassContainer
            height="150%"
            bigger_height="100%"
            width="100%"
            inside={
              <img
                src="https://api.zenofy.tr/chatrivo_images/mobil-2.jpg"
                alt="chatrivo ss"
                style={{ maxWidth: "90%", paddingBottom: "5%", paddingTop: "5%" }}
              />
            }
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "1rem",
            width: args.device === "phone" ? "400%" : "100%",
          }}
        >
          <GlassContainer
            height="150%"
            bigger_height="100%"
            width="100%"
            inside={
              <img
                src="https://api.zenofy.tr/chatrivo_images/mobil-3.jpg"
                alt="chatrivo ss"
                style={{ maxWidth: "90%", paddingBottom: "5%", paddingTop: "5%" }}
              />
            }
          />
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "row", margin: "1rem", maxWidth: args.device !== "phone" ? "40%" : "100%" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "1rem" }}>
          <GlassContainer
            height="100%"
            bigger_height="100%"
            width="100%"
            inside={
              <img
                src="https://api.zenofy.tr/chatrivo_images/mobil-4.jpg"
                alt="chatrivo ss"
                style={{ maxWidth: "90%", paddingBottom: "5%", paddingTop: "5%" }}
              />
            }
          />
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "1rem" }}>
          <GlassContainer
            height="100%"
            bigger_height="100%"
            width="100%"
            inside={
              <img
                src="https://api.zenofy.tr/chatrivo_images/mobil-5.jpg"
                alt="chatrivo ss"
                style={{ maxWidth: "90%", paddingBottom: "5%", paddingTop: "5%" }}
              />
            }
          />
        </div>
      </div>
    </div>
  );
}

/*<GlassContainer
              width={args.device === "phone" ? "90vw" : "60vw"}
              height="40rem"
              bigger_height="50rem"
              device={args.device}
              inside={
                <div
                  style={{
                    padding: "1rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Carousel
                    style={{
                      width: "80vw",
                      height: args.device === "phone" ? "40rem" : "50rem",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                    autoplay={{ dotDuration: true }}
                    autoplaySpeed={5000}
                    draggable
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Title style={title(args.device)}>
                        <div
                          style={{
                            width: "100%",
                            height: args.device === "phone" ? "40rem" : "50rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          1
                        </div>
                      </Title>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Title style={title(args.device)}>
                        <div
                          style={{
                            width: "100%",
                            height: args.device === "phone" ? "40rem" : "50rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          2
                        </div>
                      </Title>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Title style={title(args.device)}>
                        <div
                          style={{
                            width: "100%",
                            height: args.device === "phone" ? "40rem" : "50rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          3
                        </div>
                      </Title>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Title style={title(args.device)}>
                        <div
                          style={{
                            width: "100%",
                            height: args.device === "phone" ? "40rem" : "50rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          4
                        </div>
                      </Title>
                    </div>
                  </Carousel>
                </div>
              }
            ></GlassContainer> */
